/**
 * @param {unknown[]} seeded
 */
export function assignAssistantVersions(seeded) {
  /** @type {Map<string, Set<number>>} */
  const userVersionsByExchange = new Map()
  for (const m of seeded) {
    if (!m || typeof m !== 'object') continue
    if (m.role !== 'user') continue
    const exId = m.exchangeId ?? m.id
    const v = typeof m.versionIndex === 'number' ? m.versionIndex : 0
    if (!userVersionsByExchange.has(exId)) userVersionsByExchange.set(exId, new Set())
    userVersionsByExchange.get(exId)?.add(v)
  }

  /** @type {Map<string, Map<number, number>>} */
  const assistantCounters = new Map()
  const bumpCounter = (exchangeId, versionIndex) => {
    if (!assistantCounters.has(exchangeId)) assistantCounters.set(exchangeId, new Map())
    const map = assistantCounters.get(exchangeId)
    const next = (map?.get(versionIndex) ?? 0) + 1
    map?.set(versionIndex, next)
    return next - 1
  }

  return seeded.map((m) => {
    if (!m || typeof m !== 'object') return m
    if (m.role !== 'assistant') return m

    const exchangeId = m.exchangeId ?? m.id
    const rawVersionIndex = typeof m.versionIndex === 'number' ? m.versionIndex : 0
    const userVersions = [...(userVersionsByExchange.get(exchangeId) ?? new Set())].sort((a, b) => a - b)
    if (!userVersions.length) {
      const assistantVersionIndex = typeof m.assistantVersionIndex === 'number' ? m.assistantVersionIndex : 0
      return { ...m, versionIndex: rawVersionIndex, assistantVersionIndex }
    }

    const targetQueryVersion = userVersions.includes(rawVersionIndex)
      ? rawVersionIndex
      : userVersions.reduce((acc, v) => (v <= rawVersionIndex ? v : acc), userVersions[0])

    const assistantVersionIndex =
      typeof m.assistantVersionIndex === 'number' ? m.assistantVersionIndex : bumpCounter(exchangeId, targetQueryVersion)

    return { ...m, versionIndex: targetQueryVersion, assistantVersionIndex }
  })
}
